import React, { Fragment } from 'react'
import _ from 'lodash'
import { formatPhoneNumber } from '../../../../utils/formatters'
import ListingBadge, { BADGE_MODE } from './base'
import { isTPS, getForeclosureContact } from './utils'

export default class ForeclosureContactInformationBadge extends ListingBadge {
  static title = 'Foreclosure Contact Info'

  static titleIcon = 'phone'

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      isTPS(listing) &&
      _.isPlainObject(getForeclosureContact(listing))
    )
  }

  get content() {
    const contact = getForeclosureContact(this.props.listing) || {}

    return (
      <>
        {contact.party_name}
        {contact.party_phone && (
          <div>
            Borrowers/homeowners should call{' '}
            <a href={`tel:${contact.party_phone}`}>
              {formatPhoneNumber(contact.party_phone)}
            </a>
          </div>
        )}
      </>
    )
  }
}
